import { css } from 'lit';
import sharedStyles from '../../../shared/styles';

export default [
  sharedStyles,
  css`
    a {
      color: var(--tenable-link-color, #0079dd);
      text-decoration: var(--tenable-link-decoration, none);
    }

    .job-filter-option-container {
      display: flex;
    }

    .job-filter-dropdown:first-child {
      margin-left: 0px;
      margin-right: 10px;
    }

    .job-filter-dropdown {
      margin-left: 10px;
      margin-right: 10px;
    }

    .job-filter-dropdown.country {
      margin-left: 10px;
      margin-right: 1px;
    }

    .job-filter-dropdown.location {
      margin-left: 1px;
      margin-right: 10px;
    }

    .clear-all-button {
      display: flex;
      position: relative;
      margin-left: 10px;
      align-items: center;
      cursor: pointer;

      span {
        margin-left: 1.2rem;
        color: var(--tenable-link-color, #026EDD)
      }
    }

    .x-icon {
      position: absolute;
      top: .71rem;
    }

    .job-filter-item {
      padding-left: var(--tenable-job-filter-item-padding-left, .5rem);
      padding-right: var(--tenable-job-filter-item-padding-right, 1rem);
      padding-top: var(--tenable-job-filter-item-padding-x, .25rem);
      padding-bottom: var(--tenable-job-filter-item-padding-x, .25rem);
      position: relative;

      .label {
        padding-left: var(--tenable-job-filter-item-label-left-padding, 20px);
      }

      &.clear {
        cursor: pointer;
      }

      .x-icon {
        position: absolute;
        top: .39rem;
      }

      span {
        margin-left: 1.2rem;
        color: var(--tenable-link-color, #026EDD)
      }
    }

    .hover:hover {
      background-color: var(--tenable-job-filter-hover-color, #f0f1f3);
    }

    .job-filter-checkbox {
      position: absolute;
      top: var(--tenable-job-filter-checkbox-top-padding, .4rem);
    }

    @media(max-width: 768px) {
      .filter-toggle {
        margin: var(--tenable-job-filter-toggle-margin, 1.5rem 0rem 0rem 0rem);
        postion: relative;

        tenable-icon-option {
          position: absolute;
          margin-left: -.2rem
        }

        span {
          color: var(--tenable-link-color, #026EDD);
          margin-left: 1.5rem;
          cursor: pointer;
        }
      }

      .job-filter-option-container {
        display: grid;

        .job-filter-dropdown {
          margin: var(--tenable-job-filter-dropdown-mobile-margin, .6rem 0rem 0rem 0rem);
        }

        .clear-all-button {
          margin: var(--tenable-job-filter-dropdown-mobile-margin, .6rem 0rem 0rem 0rem);

          .x-icon {
            position: absolute;
            top: .15rem;
          }
        }
      }
    }
  `,
];
